module.exports = __webpack_public_path__ + "img/icon-notification-light-blue.7e8db24a.svg";